import './styles.scss';
import React, { useState } from 'react';
import track from 'react-tracking';

import { Waypoint } from 'react-waypoint';
import { Icon } from '@edx/paragon';
import { Person } from '@edx/paragon/icons';

import CloudflareImage from '@prospectus/common/ui/CloudflareImage';

import { getMarketingSiteLink } from '@utils/edxLinks';
import { getFullName } from '@utils/formatting';
import { submitEvent } from '@utils/analytics';
import { getWebviewUrl } from '@utils/program';
import { WebviewContext } from '@utils/context';

import InstructorCardProps from './propTypes';

const instructorPhotoSize = 50;

function InstructorCard(props) {
  const [onScreen, setOnScreen] = useState(false);

  const {
    classList,
    profileImageUrl: imageUrl,
    position,
    slug,
    tracking,
    givenName,
    familyName,
  } = props;

  const handleClick = (event) => {
    const componentProps = {
      category: 'navigation',
      link: event.currentTarget.pathname.link,
    };

    submitEvent(tracking, componentProps, 'edx.bi.link.instructor.clicked');
  };

  const handleWaypointEnter = () => {
    setOnScreen(true);
  };

  const instructorUrl = getMarketingSiteLink(`/bio/${slug}`);

  return (
    <Waypoint onEnter={handleWaypointEnter}>
      <div className={classList}>
        <div className="instructor-card-wrapper">
          <div className="instructor-image-wrapper">
            {onScreen && (
              <CloudflareImage
                className="rounded-circle w-100"
                url={imageUrl}
                width={instructorPhotoSize}
                height={instructorPhotoSize}
                title={`${givenName} ${familyName}`}
              />
            )}
            {!onScreen && (
              <div className="default-user">
                <Icon src={Person} style={{ height: '2rem', width: '2rem' }} />
              </div>
            )}
          </div>
          <div className="d-flex flex-column instructor-details">
            <WebviewContext.Consumer>
              {(webview) => (
                <a
                  href={webview ? getWebviewUrl(`/bio/${slug}`) : instructorUrl}
                  className="name font-weight-bold"
                  onClick={handleClick}
                >
                  {getFullName(props)}
                </a>
              )}
            </WebviewContext.Consumer>
            {position && (
              <>
                <div className="title font-italic">{position.title}</div>
                <div className="org">{position.organizationName}</div>
              </>
            )}
          </div>
        </div>
      </div>
    </Waypoint>
  );
}

InstructorCard.propTypes = InstructorCardProps;

InstructorCard.defaultProps = {
  position: null,
  classList: '',
  tracking: {},
};

export default track({
  component: 'instructor-card',
})(InstructorCard);
